import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["SinglePhoneComponent", "builders", "sellers", "withoutModal", "singlePhoneButtonText", "multiplePhoneButtonText", "onOpenContactsClick", "onShowPhoneClick", "showPhoneStyles", "openContactsStyles", "openContactsSellerPhoneStyles", "openContactsBuilderPhoneStyles"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import * as React from 'react';
import { filterBuilders } from '../../utils/filterBuilders';
import { filterSellers } from '../../utils/filterSellers';
import { getIsLeadFactory } from '../../utils/isLeadFactory';
import { isShowPhoneImmediately } from '../../utils/isShowPhoneImmediately';
import { isEmptyRendering } from '../../utils/isEmptyRendering';
import { getSinglePhoneData } from '../../utils/getSinglePhoneData';
import { PhoneButton } from '../PhoneButton';
import { InfosPopup } from '../InfosPopup/InfosPopup';
import { jsx as _jsx } from "react/jsx-runtime";
export var SimpleCall = function SimpleCall(_ref) {
  var SinglePhoneComponent = _ref.SinglePhoneComponent,
    builders = _ref.builders,
    sellers = _ref.sellers,
    withoutModal = _ref.withoutModal,
    singlePhoneButtonText = _ref.singlePhoneButtonText,
    multiplePhoneButtonText = _ref.multiplePhoneButtonText,
    onOpenContactsClick = _ref.onOpenContactsClick,
    onShowPhoneClick = _ref.onShowPhoneClick,
    showPhoneStyles = _ref.showPhoneStyles,
    openContactsStyles = _ref.openContactsStyles,
    openContactsSellerPhoneStyles = _ref.openContactsSellerPhoneStyles,
    openContactsBuilderPhoneStyles = _ref.openContactsBuilderPhoneStyles,
    commonProps = _objectWithoutProperties(_ref, _excluded);
  var buildersWithPhones = filterBuilders(builders);
  var sellersWithPhones = filterSellers(sellers);
  var isLeadFactory = getIsLeadFactory(sellersWithPhones);
  var showPhoneImmediately = isShowPhoneImmediately({
    builders: buildersWithPhones,
    sellers: sellersWithPhones,
    isLeadFactory: isLeadFactory,
    withoutModal: withoutModal
  });
  if (isEmptyRendering({
    builders: buildersWithPhones,
    sellers: sellersWithPhones
  })) {
    return null;
  }
  if (showPhoneImmediately) {
    var _getSinglePhoneData = getSinglePhoneData({
        builders: buildersWithPhones,
        sellers: sellersWithPhones
      }),
      siteBlockId = _getSinglePhoneData.siteBlockId,
      phone = _getSinglePhoneData.phone,
      buttonText = _getSinglePhoneData.buttonText,
      realtyUserId = _getSinglePhoneData.realtyUserId,
      isOpen = _getSinglePhoneData.isOpen;
    return /*#__PURE__*/_jsx(PhoneButton, _objectSpread(_objectSpread({}, commonProps), {}, {
      PhoneComponent: SinglePhoneComponent,
      realtyUserId: realtyUserId,
      siteBlockId: siteBlockId,
      phone: phone,
      buttonText: singlePhoneButtonText || buttonText,
      onClick: onShowPhoneClick,
      styles: showPhoneStyles,
      isOpen: isOpen,
      phoneButtonTestId: "PhoneButton"
    }));
  }
  return /*#__PURE__*/_jsx(InfosPopup, _objectSpread(_objectSpread({}, commonProps), {}, {
    builders: buildersWithPhones,
    sellers: sellersWithPhones,
    multiplePhoneButtonText: multiplePhoneButtonText,
    onModalOpen: onOpenContactsClick,
    onPhoneOpen: onShowPhoneClick,
    openContactsStyles: openContactsStyles,
    openContactsSellerPhoneStyles: openContactsSellerPhoneStyles,
    openContactsBuilderPhoneStyles: openContactsBuilderPhoneStyles,
    phoneButtonTestId: "ShowPhonePopupButton"
  }));
};